export default function select({ variables }) {
    return {
        MuiSelect: {
            defaultProps: {
                variant: "outlined",
            },
            styleOverrides: {
                root: {
                    height: variables.component_height_medium,
                    "&.MuiInputBase-sizeSmall": {
                        height: variables.component_height_small,
                    },
                    "&.MuiInputBase-sizeLarge": {
                        height: variables.component_height_large,
                    },
                },
                select: {
                    fontWeight: variables.font_weight_medium,
                    "& .Mui-selected": {
                        paddingRight: variables.spacing_07,
                        backgroundColor: "transparent",
                    },
                },
                outlined: {
                    paddingRight: `${variables.spacing_09} !important`, //TODO: figure out how to override this properly
                },
                icon: {
                    color: variables.border_strong,
                },
            },
        },
    };
}
//# sourceMappingURL=select.js.map